function t() {
  return {
    textMargin: "4px",
    dividerMargin: "16px",
    positionLeftWidth: "16px",
    positionRightWidth: "16px",
    fontSize: "13px",
    lineHeight: "18px",
    textColor: "var(--gray-600)",
    color: "var(--gray-200)"
  };
}
function i(e) {
  return {
    default: () => t()
  }[e]();
}
export {
  i as createDividerTheme
};
//# sourceMappingURL=highrise.es339.js.map
